<template>
  <popup :close-action="closeActionClicked" class="eom-celebration-generic-popup">
    <template v-slot:content>
      <slot></slot>
      <share-button filename="eom" share-name="EomCelebration"
                    :share-component="shareComponent" :share-component-props="shareComponentProps"
                    :segment-extra-props="segmentExtraProps" v-slot="slotProps" :show-popup="false">
        <riseup-button variant="primary"
                       size="slim"
                       :title="cta"
                       :action="slotProps.onClick"
                       :loading="slotProps.loading"/>
      </share-button>
    </template>
  </popup>
</template>

<script>

import BaseUI from 'base-ui';
import ShareButton from '@/base-components/share/ShareButton';
import Segment from '@/Segment';
import { mapActions } from 'vuex';

export default {
  name: 'EomCelebrationGenericPopup',
  components: {
    Popup: BaseUI.Popup,
    RiseupButton: BaseUI.RiseupButton,
    ShareButton,
  },
  props: {
    segmentExtraProps: {
      type: Object,
      require: true,
    },
    cashflowDate: {
      type: String,
      require: true,
    },
    cta: {
      type: String,
      require: false,
      default: 'לשתף עם העולם',
    },
    shareComponent: {
      type: Object,
    },
    shareComponentProps: {
      type: Object,
    },
  },
  data() {
    return {
      isSharing: false,
      shareAssetPromise: null,
    };
  },
  created() {
    Segment.trackUserGot('EOMCelebrationPopupShownV2', this.segmentExtraProps);
  },
  methods: {
    ...mapActions('share', ['setCelebrationDismissed']),
    ...mapActions('modalRootStore', ['closeModal']),
    closeActionClicked() {
      Segment.trackUserInteraction('EOMCelebrationPopupClosed', this.segmentExtraProps);
      this.close();
    },
    close() {
      this.setCelebrationDismissed(this.cashflowDate);
      this.closeModal();
    },
  },
};
</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.popup.eom-celebration-generic-popup {
  .top {
    .share-button {
      margin-top: 30px;
    }
  }
}

</style>
